import moment from 'moment';
import { SELLING_PLATFORM_OPTIONS, LISTING_TYPE_OPTIONS } from '../constants';
import { toCurrency, toPercentage, toDate } from './format.util';

const ALL_TIME_HIGH_TEXT = [
  'set an all-time high',
  'notched a record high',
  'established a record high',
  'achieved an all-time high',
  'established a record high',
  'notched a new high',
  'established a new high',
];

export async function getGeneratedAllTimeHighNote(cardId, cardService, saleService, index) {
  const cardNote = {};

  try {
    const YEARS_AGO = 10;
    const ladderCard = await cardService.getCard(cardId);
    const allTimeHighSale = await saleService.getAllTimeHighSale(cardId);
    const previousSale = await saleService.findClosestSale(
      cardId,
      moment(allTimeHighSale.date).subtract(1, 'years').toDate(),
      moment(allTimeHighSale.date).subtract(YEARS_AGO, 'years').toDate(),
      moment(allTimeHighSale.date).subtract(5, 'days').toDate(),
    );

    let text = '';

    cardNote.card = cardId;
    cardNote.cardLabel = ladderCard.label || '';
    cardNote.cardImage = ladderCard.image || '';
    cardNote.id = cardId;
    cardNote.year = ladderCard.year || '';
    cardNote.set = ladderCard.set || '';
    cardNote.player = ladderCard.player || '';
    cardNote.condition = ladderCard.condition || '';
    cardNote.variation = ladderCard.variation || '';
    cardNote.image = ladderCard.image || '';
    cardNote.number = ladderCard.number || '';

    let soldPrice = '$SOLD_PRICE';
    let soldDate = 'SOLD_DATE';
    let soldListingType = 'SOLD_LISTING_TYPE';
    let soldPlatform = 'SOLD_PLATFORM';

    let previousSoldPrice = '$PREVIOUS_SOLD_PRICE';
    let previousSoldDate = 'PREVIOUS_SOLD_DATE';

    let timeAgo = 'TIME_AGO';
    let priceDifference = '$PRICE_DIFFERENCE';
    let roiDifference = 'ROI_DIFFERENCE%';
    let salesSince = 'SALES_SINCE';

    if (allTimeHighSale && previousSale) {
      soldPrice = toCurrency(allTimeHighSale.price, { full: true });
      soldDate = toDate(allTimeHighSale.date);
      soldListingType = LISTING_TYPE_OPTIONS.find(({ value }) => value === allTimeHighSale.listingType).label;
      soldPlatform = SELLING_PLATFORM_OPTIONS.find(({ value }) => value === allTimeHighSale.platform).label;
      previousSoldPrice = toCurrency(previousSale.price, { full: true });
      previousSoldDate = toDate(previousSale.date);
      timeAgo = moment(previousSale.date).fromNow();
      priceDifference = toCurrency(allTimeHighSale.price - previousSale.price, { full: true });
      roiDifference = toPercentage((allTimeHighSale.price - previousSale.price) / previousSale.price);
      salesSince = await saleService.getNumSalesSinceDate(cardId, previousSale.date);

      text += `The ${ladderCard.label}${ladderCard.pop ? ` (pop ${ladderCard.pop})` : ''} ${ALL_TIME_HIGH_TEXT[index % ALL_TIME_HIGH_TEXT.length]} `;
      text += `when it sold for ${soldPrice} (${soldDate}) via ${soldListingType} with ${soldPlatform}.  `;
      text += `The ${ladderCard.player === 'Box' ? 'box' : 'card'} sold for ${previousSoldPrice} (${previousSoldDate}) ${timeAgo.replace('ago', index % 2 === 0 ? 'ago' : 'earlier')}.  `;
      text += `It's up ${roiDifference} (${priceDifference})${salesSince > 1 ? ` and has sold ${salesSince} times since.` : '.'}`;
    } else {
      text += `THIS CARD DOES NOT HAVE A SALE IN THE LAST ${YEARS_AGO} YEARS. PLEASE REMOVE THIS FROM HEADLINES`;
    }

    cardNote.title = 'All-time High';
    cardNote.text = text;
  } catch (e) {
    // swallow
  }

  return cardNote;
}
